const intervals = [];

const availableActions = {
	start: 'start',
	stop: 'stop'
};

export const create = (actionsNamespace, config) => {
	const listOfActions = availableActions;
	const actionTypes = createActionTypes(
		actionsNamespace,
		config,
		listOfActions
	);
	return {
		initState: config,
		actions: getActions(
			actionTypes,
			listOfActions,
			config
		)
	};
};

const createActionTypes = (namespaces, config, availableActions) => {
	const mask = '{MODULE_NAMESPACE}/{COMPONENT_NAME}-polling-{ACTION}';
	const actions = Object.keys(availableActions);

	let actionsTypes = {};

	Object.keys(config).forEach(componentName => {
		actionsTypes[componentName] = {};
		actions.forEach(action => {
			actionsTypes[componentName][action] = (
				mask.replace('{MODULE_NAMESPACE}', namespaces)
					.replace('{COMPONENT_NAME}', componentName)
					.replace('{ACTION}', action)
			);
		});
	});

	return actionsTypes;
};

const getActions = (actionTypes, availableActions, config) => ({
	start: (componentName, intervalName, action, dispatch) => {
		if (!intervals[componentName]) {
			intervals[componentName] = [];
		}
		if (!intervals[componentName][intervalName]) {
			intervals[componentName][intervalName] = setInterval(
				() => dispatch(action),
				config[intervalName].interval
			);
		}
	},
	stop: (componentName, intervalName) => {
		const poller = intervals[componentName] && intervals[componentName][intervalName] || null;
		if (poller) {
			clearInterval(intervals[componentName][intervalName]);
			intervals[componentName][intervalName] = null;
		}
	}
});



// WEBPACK FOOTER //
// ./frontend/shared/js/intervals.js